import React, { useEffect } from "react";
import TeamDetailsTableSimple from "./TeamDetailsTableSimple.jsx";
import TeamDetailsTablePerStage from "./TeamDetailsTablePerStage.jsx";
import TeamDetailsTableAchievements from "./TeamDetailsTableAchievements.jsx";

const TeamDetailsTable = ({ columns, stages, activeStage, team, achievements, game, startlist }) => {
  let stagesFiltered = false;
  let upcomingStagesFiltered = false;
  if (stages !== false) {  
    stagesFiltered = stages.filter(stage => stage.gameStatus);
    upcomingStagesFiltered = stages.filter(stage => !stage.gameStatus);
  }
  return (
    
    <div className="team-details__wrap">
      <div className={`team-details__table ${(!stagesFiltered && !achievements ? 'team-details__table--full-width' : '')} ${(achievements ? 'team-details__table--achievements' : '')}`}>
        <TeamDetailsTableSimple
          team={team}
          columns={columns}
          stages={stagesFiltered}
          upcomingStages={upcomingStagesFiltered}
          activeStage={activeStage}
          startlist={startlist}
        />
      </div>
      <div className={`team-details__left-table ${(achievements ? 'team-details__left-table--achievements' : '')}`}>
        <TeamDetailsTableAchievements
          team={team}
          achievements={achievements}
        />
        <TeamDetailsTablePerStage
          team={team}
          columns={columns}
          stages={stagesFiltered}
          activeStage={activeStage}
          game={game}
        />
      </div>
    </div>
  );
};

export default TeamDetailsTable;
